import * as Yup from 'yup';

function extractSpecification(formik, name) {
  const specification = formik?.values?.specifications?.[name];
  if (Array.isArray(specification)) {
    return specification;
  }
  return !specification ? [] : specification === '' ? [] : [specification];
}
const handleSelectChange = (formik, fieldName) => (e) => {
  const selectedValues = e.target.value;
  // Если выбрана опция 'None', сбрасываем поле в пустой массив
  if (selectedValues.includes('')) {
    formik.setFieldValue(fieldName, []); // Сбрасываем в пустой массив
  } else {
    formik.setFieldValue(fieldName, selectedValues); // Устанавливаем выбранные значения
  }
};
const getItemsQualifiers = (selectedCategories = []) => {
  const selectedQualifiers = [];

  if (selectedCategories.length === 0) {
    // Если selectedCategories пустой, возвращаем все данные из всех категорий
    Object.keys(categoryToQualifiers).forEach((category) => {
      selectedQualifiers.push(...categoryToQualifiers[category]);
    });
  } else {
    // Иначе, возвращаем данные только из выбранных категорий
    selectedCategories.forEach((category) => {
      if (categoryToQualifiers[category]) {
        selectedQualifiers.push(...categoryToQualifiers[category]);
      }
    });
  }

  return selectedQualifiers;
};

const categoryToQualifiers = {
  'stress-analysis-gages': [
    { id: 'linear', label: 'Linear (stress analysis gages)' },
    { id: 'tee_rosette', label: 'Tee Rosette (stress analysis gages)' },
    { id: 'sheartorque_rosettes', label: 'Shear Torque Rosettes (stress analysis gages)' },
    { id: 'rectangular_rosette', label: 'Rectangular Rosette (stress analysis gages)' },
    { id: 'delta_rosette', label: 'Delta Rosette (stress analysis gages)' },
  ],
  'special-use-gages': [
    { id: 'high_temp_foil', label: 'High Temperature Foil (special use gages)' },
    { id: 'displacement_sensor', label: 'Displacement Sensor (special use gages)' },
    { id: 'temperature_sensors', label: 'Temperature Sensors (special use gages)' },
    { id: 'high_temp_wire', label: 'High Temperature Wire (special use gages)' },
    { id: 'crack_propagation', label: 'Crack Propagation (special use gages)' },
    { id: 'residual_stress', label: 'Residual Stress (special use gages)' },
    { id: 'weldable', label: 'Weldable (special use gages)' },
    { id: 'displacement', label: 'Displacement (special use gages)' },
    { id: 'linear_displacement_sensor', label: 'Linear Displacement Sensor (special use gages)' },
    { id: 'crack_detection', label: 'Crack Detection (special use gages)' },
    { id: 'pressure_pulse', label: 'Pressure Pulse (special use gages)' },
    { id: 'shear_modulus_testing', label: 'Shear Modulus Testing (special use gages)' },
    { id: 'magnetic', label: 'Magnetic (special use gages)' },
    { id: 'shear_modulus', label: 'Shear Modulus (special use gages)' },
    { id: 'temperature', label: 'Temperature (special use gages)' },
    { id: 'cryogenic_temp_sensor', label: 'Cryogenic Temperature Sensor (special use gages)' },
    { id: 'concrete', label: 'Concrete (special use gages)' },
    { id: 'high_temp_weldable', label: 'High Temperature Weldable (special use gages)' },
  ],
  'transducer-class-gages': [
    { id: 'linear_patterns', label: 'Linear Patterns (transducer class gages)' },
    { id: 'shear_patterns', label: 'Shear Patterns (transducer class gages)' },
    { id: '90_patterns', label: '90° Patterns (transducer class gages)' },
    { id: 'full_bridge_patterns', label: 'Full Bridge Patterns (transducer class gages)' },
    { id: 'bondable_resistors', label: 'Bondable Resistors (transducer class gages)' },
    { id: 'platinum_tungsten', label: 'Platinum Tungsten (transducer class gages)' },
    { id: 'diaphragm_patterns', label: 'Diaphragm Patterns (transducer class gages)' },
  ],
  accessories: [
    { id: 'wires_and_cables', label: 'Wires And Cables (accessories)' },
    { id: 'precision_resistors', label: 'Precision Resistors (accessories)' },
    { id: 'adhesives', label: 'Adhesives (accessories)' },
    { id: 'installation_tools', label: 'Installation Tools (accessories)' },
    { id: 'bondable_terminals', label: 'Bondable Terminals (accessories)' },
    { id: 'protective_coatings', label: 'Protective Coatings (accessories)' },
    { id: 'solders_and_accessories', label: 'Solders And Accessories (accessories)' },
    { id: 'bridge_completion_modules', label: 'Bridge Completion Modules (accessories)' },
    { id: 'surface_cleaning', label: 'Surface Cleaning (accessories)' },
    { id: 'application_kits', label: 'Application Kits (accessories)' },
  ],
  instruments: [
    { id: 'digital_data_systems', label: 'Digital Data Systems (instruments)' },
    { id: 'signal_conditioning_amplifiers', label: 'Signal Conditioning Amplifiers (instruments)' },
    { id: 'educational', label: 'Educational (instruments)' },
    {
      id: 'strain_indicator_and_calibrators',
      label: 'Strain Indicator And Calibrators (instruments)',
    },
    { id: 'special_purpose_equipmment', label: 'Special Purpose Equipment (instruments)' },
  ],
  none: [],
};

const changeQualifiersItems = (bu, category, fieldId, newItems) => {
  // Ищем нужный элемент формы в конфигурации
  const formConfig = formsConfig[bu]?.[category];
  if (!formConfig) {
    console.error(`Configuration for bu: ${bu} and category: ${category} not found.`);
    return;
  }

  // Находим поле с нужным id и обновляем его items
  const field = formConfig.formFields.find((field) => field.props.id === fieldId);
  if (!field) {
    console.error(`Field with id: ${fieldId} not found in category: ${category}`);
    return;
  }

  // Обновляем items для поля
  field.props.items = newItems;
};

const handleCategoryChange = (formik, category_name) => (e) => {
  const selectedCategories = e.target.value;
  if (Array.isArray(selectedCategories) && selectedCategories.includes('')) {
    // empty
    formik.setFieldValue('additional_categories', []);
    formik.setFieldValue('additional_qualifiers', []);
    // set empty to additional_qualifiers
    changeQualifiersItems(formik.values.business_unit, category_name, 'additional_qualifiers', [
      { id: '', label: 'None' },
    ]);
  } else {
    formik.setFieldValue('additional_categories', selectedCategories);
    const items = [{ id: '', label: 'None' }, ...getItemsQualifiers(selectedCategories)];
    // set additional_qualifiers to specific category by category_name
    changeQualifiersItems(
      formik.values.business_unit,
      category_name,
      'additional_qualifiers',
      items,
    );
  }
};

const handleMultiSelectChange = (formik, fieldName) => (e) => {
  const { value } = e.target;

  if (
    fieldName === 'additional_qualifiers' &&
    (!formik.values.additional_categories || formik.values.additional_categories.length === 0)
  ) {
    formik.setFieldError(
      fieldName,
      'You cannot select additional qualifiers if no additional categories are selected',
    );
    return;
  }

  if (Array.isArray(value) && value.includes('')) {
    // Если выбрана опция "None" (с value === ''), сбрасываем значение поля
    formik.setFieldValue(fieldName, []);
  } else {
    formik.setFieldValue(fieldName, typeof value === 'string' ? value.split(',') : value);
  }
};

const handleLoadQualifiers = (formik, category_name) => {
  const selectedCategories = formik.values.additional_categories;
  const items = [{ id: '', label: 'None' }, ...getItemsQualifiers(selectedCategories)];
  changeQualifiersItems(formik.values.business_unit, category_name, 'additional_qualifiers', items);
};

const additionalQualifiersValidation = Yup.array().when('additional_categories', {
  is: (categories) => !categories || categories.length === 0,
  then: Yup.array().test(
    'no-qualifiers',
    'You cannot select additional qualifiers if no additional categories are selected',
    (value) => !value || value.length === 0,
  ),
  otherwise: Yup.array(),
});

let formsConfig = {
  mm: {
    'stress-analysis-gages': {
      initialValues: {
        name: '',
        long_name: '',
        qualifier: [],
        description: '',
        keywords: [],
        weight: '',
        images: {},
        res_id: '',
        specifications: {},
        characteristics: {},
        dimensions: { length: {}, width: {} },
        designations: {},
        doc_number: '',
        additional_categories: [],
        additional_qualifiers: [],
      },
      validationSchema: Yup.object({
        name: Yup.string().required('Required'),
        additional_qualifiers: additionalQualifiersValidation,
      }),
      formFields: [
        {
          component: 'TextField',
          props: {
            id: 'name',
            name: 'name',
            label: 'Short Product Name',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'sku',
            name: 'sku',
            label: 'Sku',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'long_name',
            name: 'long_name',
            label: 'Long Product Name',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'qualifier',
            name: 'qualifier',
            label: 'Qualifier',
            multiple: true,
            items: [
              { id: 'linear', label: 'Linear' },
              { id: 'tee_rosette', label: 'Tee Rosette' },
              { id: 'sheartorque_rosettes', label: 'Shear Torque Rosettes' },
              { id: 'rectangular_rosette', label: 'Rectangular Rosette' },
              { id: 'delta_rosette', label: 'Delta Rosette' },
              { id: 'none', label: 'None' },
            ],
            value: (formik) =>
              Array.isArray(formik.values.qualifier)
                ? formik.values.qualifier
                : typeof formik.values.qualifier === 'string'
                ? formik.values.qualifier.split(',')
                : [],
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'description',
            name: 'description',
            label: 'Description',
            multiline: true,
          },
        },
        {
          component: 'TextField',
          saveAs: 'array', // for spliting string into an array (values separated by commas)
          props: {
            id: 'keywords',
            name: 'keywords',
            label: 'Keywords',
            multiline: true,
            onChange: (formik) => (e) => {
              formik.setFieldValue('keywords', e.target.value.split(','));
            },
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'weight',
            name: 'weight',
            label: 'Weight',
            type: 'number',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'gage_length',
            name: 'specifications.stress_analysis_gage_length',
            label: 'Gage Length',
            multiple: false,
            value: (formik) => formik?.values?.specifications?.stress_analysis_gage_length,
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'strain_range',
            name: 'characteristics.strain_range',
            label: 'Strain Range',
            value: (formik) => formik.values.characteristics.strain_range,
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'temperature_range',
            name: 'characteristics.temperature_range',
            label: 'Temperature Range',
            value: (formik) => formik.values.characteristics.temperature_range,
          },
        },
        {
          component: 'MultipleSelect',
          saveAs: 'array',
          props: {
            id: 'additional_categories',
            name: 'additional_categories',
            label: 'Additional Categories',
            items: [
              { id: '', label: 'None' },
              { id: 'transducer-class-gages', label: 'Transducer Class Gages' },
              { id: 'accessories', label: 'Accessories' },
              { id: 'instruments', label: 'Instruments' },
              { id: 'special-use-gages', label: 'Special Use Gages' },
            ],
            onChange: (formik) => handleCategoryChange(formik, 'stress-analysis-gages'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'additional_qualifiers',
            name: 'additional_qualifiers',
            label: 'Additional Qualifiers',
            multiple: true,
            items: [],
            onLoad: (formik) => handleLoadQualifiers(formik, 'stress-analysis-gages'),
            onChange: (formik) => handleMultiSelectChange(formik, 'additional_qualifiers'),
          },
        },

        {
          component: 'ResourceSpace',
          props: {
            id: 'image',
            name: 'images[0]',
            label: 'Image',
            styles: {
              formControlLabelRoot: { marginRight: 0 },
            },
            value: (formik) => formik.values.images[0],
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'res_id',
            name: 'res_id',
            label: 'Datasheet',
            styles: {
              formControl: { marginLeft: '16px' },
              formControlLabelRoot: { marginRight: 0 },
            },
            createBtnText: 'Create',
            createBtnAction: 'createNewDatasheet',
            editBtnText: 'Edit',
            editBtnAction: 'editExistingDatasheet',
            previewDocText: 'Preview',
            viewBtnAction: 'getDocumentLink',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'doc_number',
            name: 'doc_number',
            label: 'Document Number',
          },
        },
      ],
      dimensions: {
        component: 'Dimensions',
      },
      designations: {
        component: 'Designations',
        props: {
          fields: [
            { name: 'series', label: 'Series' },
            { name: 'stc', label: 'Stc' },
            { name: 'resistance', label: 'Resistance' },
            { name: 'options', label: 'Options' },
            { name: 'item_code', label: 'Item Code' },
            { name: 'materials', label: 'Materials' },
            { name: 'packaging', label: 'Packaging' },
          ],
          columns: [
            { id: 'designation', label: 'Designation' },
            { id: 'item_code', label: 'Item Code' },
            { id: 'materials', label: 'Materials' },
            { id: 'packaging', label: 'Packaging' },
            { id: 'edit' },
            { id: 'delete' },
          ],
          getKey: ({ series, stc, name, resistance, options }) => {
            return `${series || 'xxx'}-${stc || 'xxx'}-${name || 'xxx'}-${resistance || 'xxx'}${
              options ? `/${options}` : ''
            }`;
          },
        },
      },
      onSubmit: (values) => {
        if (values.designations && Object.keys(values.designations).length) {
          const stcSet = new Set();
          const seriesSet = new Set();
          const resistanceSet = new Set();
          const optionsSet = new Set();
          Object.keys(values.designations).forEach((key) => {
            stcSet.add(values.designations[key].stc);
            seriesSet.add(values.designations[key].series);
            resistanceSet.add(values.designations[key].resistance);
            optionsSet.add(values.designations[key].options);
          });

          values.specifications['stress_analysis_stc'] = Array.from(stcSet);
          values.specifications['stress_analysis_series'] = Array.from(seriesSet);
          values.specifications['stress_analysis_resistance'] = Array.from(resistanceSet);
          values.specifications['stress_analysis_options'] = Array.from(optionsSet);
        }
      },
      datasheetTemplates: [4, 8],
    },
    'special-use-gages': {
      initialValues: {
        name: '',
        long_name: '',
        qualifier: [],
        description: '',
        keywords: [],
        weight: '',
        images: {},
        res_id: '',
        specifications: {},
        designations: {},
        doc_number: '',
        additional_categories: [],
        additional_qualifiers: [],
      },
      validationSchema: Yup.object({
        name: Yup.string().required('Required'),
        additional_qualifiers: additionalQualifiersValidation,
      }),
      formFields: [
        {
          component: 'TextField',
          props: {
            id: 'name',
            name: 'name',
            label: 'Short Product Name',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'sku',
            name: 'sku',
            label: 'Sku',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'long_name',
            name: 'long_name',
            label: 'Long Product Name',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'qualifier',
            name: 'qualifier',
            label: 'Qualifier',
            multiple: true,
            items: [
              { id: 'high_temp_foil', label: 'High Temperature Foil' },
              { id: 'displacement_sensor', label: 'Displacement Sensor' },
              { id: 'temperature_sensors', label: 'Temperature Sensor' },
              { id: 'high_temp_wire', label: 'High Temperature Wire' },
              { id: 'crack_propagation', label: 'Crack Propagation' },
              { id: 'residual_stress', label: 'Residual Stress' },
              { id: 'weldable', label: 'Weldable' },
              { id: 'displacement', label: 'Displacement' },
              {
                id: 'linear_displacement_sensor',
                label: 'Linear Displacement Sensor',
              },
              { id: 'crack_detection', label: 'Crack Detection' },
              { id: 'pressure_pulse', label: 'Pressure Pulse' },
              { id: 'shear_modulus_testing', label: 'Shear Modulus Testing' },
              { id: 'magnetic', label: 'Magnetic' },
              { id: 'shear_modulus', label: 'Shear Modulus' },
              { id: 'temperature', label: 'Temperature' },
              {
                id: 'cryogenic_temp_sensor',
                label: 'Cryogenic Temperature Sensor',
              },
              { id: 'concrete', label: 'Concrete' },
              { id: 'high_temp_weldable', label: 'High Temperature Weldable' },
              { id: 'none', label: 'None' },
            ],
            value: (formik) =>
              Array.isArray(formik.values.qualifier)
                ? formik.values.qualifier
                : typeof formik.values.qualifier === 'string'
                ? formik.values.qualifier.split(',')
                : [],
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'description',
            name: 'description',
            label: 'Description',
            multiline: true,
          },
        },
        {
          component: 'TextField',
          saveAs: 'array', // for spliting string into an array (values separated by commas)
          props: {
            id: 'keywords',
            name: 'keywords',
            label: 'Keywords',
            multiline: true,
            onChange: (formik) => (e) => {
              formik.setFieldValue('keywords', e.target.value.split(','));
            },
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'weight',
            name: 'weight',
            label: 'Weight',
            type: 'number',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'gage_length',
            name: 'specifications.special_use_gage_length',
            label: 'Gage Length',
            multiple: false,
            value: (formik) => formik?.values?.specifications?.special_use_gage_length,

            // value: (formik) => extractSpecification(formik, 'special_use_gage_length'),
          },
        },
        {
          component: 'MultipleSelect',
          saveAs: 'array',
          props: {
            id: 'additional_categories',
            name: 'additional_categories',
            label: 'Additional Categories',
            items: [
              { id: '', label: 'None' },
              { id: 'stress-analysis-gages', label: 'Stress Analysis Gages' },
              { id: 'transducer-class-gages', label: 'Transducer Class Gages' },
              { id: 'accessories', label: 'Accessories' },
              { id: 'instruments', label: 'Instruments' },
            ],
            onChange: (formik) => handleCategoryChange(formik, 'special-use-gages'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'additional_qualifiers',
            name: 'additional_qualifiers',
            label: 'Additional Qualifiers',
            multiple: true,
            items: [],
            onLoad: (formik) => handleLoadQualifiers(formik, 'special-use-gages'),

            onChange: (formik) => handleMultiSelectChange(formik, 'additional_qualifiers'),
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'image',
            name: 'images[0]',
            label: 'Image',
            styles: {
              formControlLabelRoot: { marginRight: 0 },
            },
            value: (formik) => formik.values.images[0],
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'res_id',
            name: 'res_id',
            label: 'Datasheet',
            styles: {
              formControl: { marginLeft: '16px' },
              formControlLabelRoot: { marginRight: 0 },
            },
            createBtnText: 'Create',
            createBtnAction: 'createNewDatasheet',
            editBtnText: 'Edit',
            editBtnAction: 'editExistingDatasheet',
            previewDocText: 'Preview',
            viewBtnAction: 'getDocumentLink',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'doc_number',
            name: 'doc_number',
            label: 'Document Number',
          },
        },
      ],
      designations: {
        component: 'Designations',
        props: {
          fields: [
            { name: 'series', label: 'Series' },
            { name: 'stc', label: 'Stc' },
            { name: 'resistance', label: 'Resistance' },
            { name: 'options', label: 'Options' },
            { name: 'item_code', label: 'Item Code' },
            { name: 'materials', label: 'Materials' },
            { name: 'packaging', label: 'Packaging' },
          ],
          columns: [
            { id: 'designation', label: 'Designation' },
            { id: 'item_code', label: 'Item Code' },
            { id: 'materials', label: 'Materials' },
            { id: 'packaging', label: 'Packaging' },
            { id: 'edit' },
            { id: 'delete' },
          ],
          getKey: ({ series, stc, name, resistance, options }) => {
            return `${series || 'xxx'}-${stc || 'xxx'}-${name || 'xxx'}-${resistance || 'xxx'}${
              options ? `/${options}` : ''
            }`;
          },
        },
      },
      onSubmit: (values) => {
        if (values.designations && Object.keys(values.designations).length) {
          const stcSet = new Set();
          const seriesSet = new Set();
          const resistanceSet = new Set();
          const optionsSet = new Set();
          Object.keys(values.designations).forEach((key) => {
            stcSet.add(values.designations[key].stc);
            seriesSet.add(values.designations[key].series);
            resistanceSet.add(values.designations[key].resistance);
            optionsSet.add(values.designations[key].options);
          });

          values.specifications['special_use_stc'] = Array.from(stcSet);
          values.specifications['special_use_series'] = Array.from(seriesSet);
          values.specifications['special_use_resistance'] = Array.from(resistanceSet);
          values.specifications['special_use_options'] = Array.from(optionsSet);
        }
      },
      datasheetTemplates: [8],
    },
    'transducer-class-gages': {
      initialValues: {
        name: '',
        long_name: '',
        qualifier: [],
        description: '',
        keywords: [],
        weight: '',
        images: {},
        res_id: '',
        specifications: {},
        dimensions: { length: {}, width: {} },
        designations: {},
        doc_number: '',
        additional_categories: [],
        additional_qualifiers: [],
      },
      validationSchema: Yup.object({
        name: Yup.string().required('Required'),
        additional_qualifiers: additionalQualifiersValidation,
      }),
      formFields: [
        {
          component: 'TextField',
          props: {
            id: 'name',
            name: 'name',
            label: 'Short Product Name',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'sku',
            name: 'sku',
            label: 'Sku',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'long_name',
            name: 'long_name',
            label: 'Long Product Name',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'qualifier',
            name: 'qualifier',
            label: 'Qualifier',
            multiple: true,
            items: [
              { id: 'linear_patterns', label: 'Linear Patterns' },
              { id: 'shear_patterns', label: 'Shear Patterns' },
              { id: '90_patterns', label: '90 Patterns' },
              { id: 'full_bridge_patterns', label: 'Full Bridge Patterns' },
              { id: 'bondable_resistors', label: 'Bondable Resistors' },
              { id: 'platinum_tungsten', label: 'Platinum Tungsten' },
              { id: 'diaphragm_patterns', label: 'Diaphragm Patterns' },
              { id: 'none', label: 'None' },
            ],
            value: (formik) =>
              Array.isArray(formik.values.qualifier)
                ? formik.values.qualifier
                : typeof formik.values.qualifier === 'string'
                ? formik.values.qualifier.split(',')
                : [],
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'description',
            name: 'description',
            label: 'Description',
            multiline: true,
          },
        },
        {
          component: 'TextField',
          saveAs: 'array', // for spliting string into an array (values separated by commas)
          props: {
            id: 'keywords',
            name: 'keywords',
            label: 'Keywords',
            multiline: true,
            onChange: (formik) => (e) => {
              formik.setFieldValue('keywords', e.target.value.split(','));
            },
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'weight',
            name: 'weight',
            label: 'Weight',
            type: 'number',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'number_of_grids',
            name: 'specifications.number_of_grids',
            label: 'Number Of Grids',
            multiline: false,
            value: (formik) => formik?.values?.specifications?.number_of_grids,
          },
        },
        {
          component: 'MultipleSelect',
          saveAs: 'array',
          props: {
            id: 'additional_categories',
            name: 'additional_categories',
            label: 'Additional Categories',
            items: [
              { id: '', label: 'None' },
              { id: 'stress-analysis-gages', label: 'Stress Analysis Gages' },
              { id: 'accessories', label: 'Accessories' },
              { id: 'instruments', label: 'Instruments' },
              { id: 'special-use-gages', label: 'Special Use Gages' },
            ],
            onChange: (formik) => handleCategoryChange(formik, 'transducer-class-gages'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'additional_qualifiers',
            name: 'additional_qualifiers',
            label: 'Additional Qualifiers',
            multiple: true,
            items: [],
            onLoad: (formik) => handleLoadQualifiers(formik, 'transducer-class-gages'),
            onChange: (formik) => handleMultiSelectChange(formik, 'additional_qualifiers'),
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'image',
            name: 'images[0]',
            label: 'Image',
            styles: {
              formControlLabelRoot: { marginRight: 0 },
            },
            value: (formik) => formik.values.images[0],
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'res_id',
            name: 'res_id',
            label: 'Datasheet',
            styles: {
              formControl: { marginLeft: '16px' },
              formControlLabelRoot: { marginRight: 0 },
            },
            createBtnText: 'Create',
            createBtnAction: 'createNewDatasheet',
            editBtnText: 'Edit',
            editBtnAction: 'editExistingDatasheet',
            previewDocText: 'Preview',
            viewBtnAction: 'getDocumentLink',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'doc_number',
            name: 'doc_number',
            label: 'Document Number',
          },
        },
      ],
      dimensions: {
        component: 'Dimensions',
      },
      designations: {
        component: 'Designations',
        props: {
          fields: [
            { name: 'series', label: 'Series' },
            { name: 'stc', label: 'Stc' },
            { name: 'resistance', label: 'Resistance' },
            { name: 'options', label: 'Options' },
            { name: 'temperature_range', label: 'Temperature Range' },
          ],
          columns: [
            { id: 'designation', label: 'Designation' },
            { id: 'temperature_range', label: 'Temperature Range' },
            { id: 'edit' },
            { id: 'delete' },
          ],
          getKey: ({ series, stc, name, resistance, options }) => {
            return `${series || 'xxx'}-${stc || 'xxx'}-${name || 'xxx'}-${resistance || 'xxx'}${
              options ? `/${options}` : ''
            }`;
          },
        },
      },
      onSubmit: (values) => {
        if (values.designations && Object.keys(values.designations).length) {
          const stcSet = new Set();
          const seriesSet = new Set();
          const resistanceSet = new Set();
          Object.keys(values.designations).forEach((key) => {
            stcSet.add(values.designations[key].stc);
            seriesSet.add(values.designations[key].series);
            resistanceSet.add(values.designations[key].resistance);
          });

          values.specifications['transducers_stc'] = Array.from(stcSet);
          values.specifications['transducers_series'] = Array.from(seriesSet);
          values.specifications['transducers_resistance'] = Array.from(resistanceSet);
        }
      },
      datasheetTemplates: [4, 8],
    },
    accessories: {
      initialValues: {
        name: '',
        qualifier: [],
        item_number: '',
        display_spec_1: '',
        display_spec_2: '',
        description: '',
        keywords: [],
        weight: '',
        images: {},
        res_id: '',
        specifications: {},
        characteristics: {},
        dimensions: { length: {}, width: {} },
        designations: {},
        doc_number: '',
        additional_categories: [],
        additional_qualifiers: [],
      },
      validationSchema: Yup.object({
        name: Yup.string().required('Required'),
        additional_qualifiers: additionalQualifiersValidation,
      }),
      formFields: [
        {
          component: 'TextField',
          props: {
            id: 'name',
            name: 'name',
            label: 'Short Product Name',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'sku',
            name: 'sku',
            label: 'Sku',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'long_name',
            name: 'long_name',
            label: 'Long Product Name',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'qualifier',
            name: 'qualifier',
            label: 'Qualifier',
            multiple: true,
            items: [
              { id: 'wires_and_cables', label: 'Wires And Cables' },
              { id: 'precision_resistors', label: 'Precision Resistors' },
              { id: 'adhesives', label: 'Adhesives' },
              { id: 'installation_tools', label: 'Installation Tools' },
              { id: 'bondable_terminals', label: 'Bondable Terminals' },
              { id: 'protective_coatings', label: 'Protective Coatings' },
              {
                id: 'solders_and_accessories',
                label: 'Solders And Accessories',
              },
              {
                id: 'bridge_completion_modules',
                label: 'Bridge Completion Modules',
              },
              { id: 'surface_cleaning', label: 'Surface Cleaning' },
              { id: 'application_kits', label: 'Application Kits' },
              { id: 'none', label: 'None' },
            ],
            value: (formik) =>
              Array.isArray(formik.values.qualifier)
                ? formik.values.qualifier
                : typeof formik.values.qualifier === 'string'
                ? formik.values.qualifier.split(',')
                : [],
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'item_number',
            name: 'item_number',
            label: 'Item Number',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'display_spec_1',
            name: 'display_spec_1',
            label: 'Display Spec 1',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'display_spec_2',
            name: 'display_spec_2',
            label: 'Display Spec 2',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'description',
            name: 'description',
            label: 'Description',
            multiline: true,
          },
        },
        {
          component: 'TextField',
          saveAs: 'array', // for spliting string into an array (values separated by commas)
          props: {
            id: 'keywords',
            name: 'keywords',
            label: 'Keywords',
            multiline: true,
            onChange: (formik) => (e) => {
              formik.setFieldValue('keywords', e.target.value.split(','));
            },
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'weight',
            name: 'weight',
            label: 'Weight',
            type: 'number',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'specifier_elongation_at_75degrees',
            name: 'specifications.specifier_elongation_at_75degrees',
            label: 'Elongation at 75 degrees',
            value: (formik) => extractSpecification(formik, 'specifier_elongation_at_75degrees'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'specifier_lower_operating_temperature_limit',
            name: 'specifications.specifier_lower_operating_temperature_limit',
            label: 'Lower operating temperature limit',
            value: (formik) =>
              extractSpecification(formik, 'specifier_lower_operating_temperature_limit'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'specifier_minimum_cure_temperature',
            name: 'specifications.specifier_minimum_cure_temperature',
            label: 'Minimum cure temperature',
            value: (formik) => extractSpecification(formik, 'specifier_minimum_cure_temperature'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'specifier_pot_life',
            name: 'specifications.specifier_pot_life',
            label: 'Pot life',
            value: (formik) => extractSpecification(formik, 'specifier_pot_life'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'specifier_shelf_life',
            name: 'specifications.specifier_shelf_life',
            label: 'Shelf life',
            value: (formik) => extractSpecification(formik, 'specifier_shelf_life'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'specifier_upper_operating_temperature_limit',
            name: 'specifications.specifier_upper_operating_temperature_limit',
            label: 'Upper operating temperature limit',
            value: (formik) =>
              extractSpecification(formik, 'specifier_upper_operating_temperature_limit'),
          },
        },
        {
          component: 'MultipleSelect',
          saveAs: 'array',
          props: {
            id: 'additional_categories',
            name: 'additional_categories',
            label: 'Additional Categories',
            items: [
              { id: '', label: 'None' },
              { id: 'stress-analysis-gages', label: 'Stress Analysis Gages' },
              { id: 'transducer-class-gages', label: 'Transducer Class Gages' },
              { id: 'instruments', label: 'Instruments' },
              { id: 'special-use-gages', label: 'Special Use Gages' },
            ],
            onChange: (formik) => handleCategoryChange(formik, 'accessories'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'additional_qualifiers',
            name: 'additional_qualifiers',
            label: 'Additional Qualifiers',
            multiple: true,
            items: [],
            onLoad: (formik) => handleLoadQualifiers(formik, 'accessories'),
            onChange: (formik) => handleMultiSelectChange(formik, 'additional_qualifiers'),
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'image',
            name: 'images[0]',
            label: 'Image',
            styles: {
              formControlLabelRoot: { marginRight: 0 },
            },
            value: (formik) => formik.values.images[0],
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'res_id',
            name: 'res_id',
            label: 'Datasheet',
            styles: {
              formControl: { marginLeft: '16px' },
              formControlLabelRoot: { marginRight: 0 },
            },
            createBtnText: 'Create',
            createBtnAction: 'createNewDatasheet',
            editBtnText: 'Edit',
            editBtnAction: 'editExistingDatasheet',
            previewDocText: 'Preview',
            viewBtnAction: 'getDocumentLink',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'doc_number',
            name: 'doc_number',
            label: 'Document Number',
          },
        },
      ],
      datasheetTemplates: [2, 3, 8],
    },
    instruments: {
      initialValues: {
        name: '',
        long_name: '',
        qualifier: [],
        item_number: '',
        display_spec_1: '',
        description: '',
        keywords: [],
        weight: '',
        images: {},
        res_id: '',
        specifications: {},
        characteristics: {},
        dimensions: { length: {}, width: {} },
        designations: {},
        doc_number: '',
        additional_categories: [],
      },
      validationSchema: Yup.object({
        name: Yup.string().required('Required'),
        additional_qualifiers: additionalQualifiersValidation,
      }),
      formFields: [
        {
          component: 'TextField',
          props: {
            id: 'name',
            name: 'name',
            label: 'Short Product Name',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'sku',
            name: 'sku',
            label: 'Sku',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'long_name',
            name: 'long_name',
            label: 'Long Product Name',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'qualifier',
            name: 'qualifier',
            label: 'Qualifier',
            multiple: true,
            items: [
              { id: 'digital_data_systems', label: 'Digital Data Systems' },
              {
                id: 'signal_conditioning_amplifiers',
                label: 'Signal Conditioning Amplifiers',
              },
              { id: 'educational', label: 'Educational' },
              {
                id: 'strain_indicator_and_calibrators',
                label: 'Strain Indicator And Calibrators',
              },
              {
                id: 'special_purpose_equipmment',
                label: 'Special Purpose Equipmment',
              },
              { id: 'none', label: 'None' },
            ],
            value: (formik) =>
              Array.isArray(formik.values.qualifier)
                ? formik.values.qualifier
                : typeof formik.values.qualifier === 'string'
                ? formik.values.qualifier.split(',')
                : [],
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'item_number',
            name: 'item_number',
            label: 'Item Number',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'display_spec_1',
            name: 'display_spec_1',
            label: 'Display Spec 1',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'description',
            name: 'description',
            label: 'Description',
            multiline: true,
          },
        },
        {
          component: 'TextField',
          saveAs: 'array', // for spliting string into an array (values separated by commas)
          props: {
            id: 'keywords',
            name: 'keywords',
            label: 'Keywords',
            multiline: true,
            onChange: (formik) => (e) => {
              formik.setFieldValue('keywords', e.target.value.split(','));
            },
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'weight',
            name: 'weight',
            label: 'Weight',
            type: 'number',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'specifier_channel',
            name: 'specifications.specifier_channel',
            label: 'Channel',
            value: (formik) => extractSpecification(formik, 'specifier_channel'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'specifier_speed',
            name: 'specifications.specifier_speed',
            label: 'Speed',
            value: (formik) => extractSpecification(formik, 'specifier_speed'),
          },
        },
        {
          component: 'MultipleSelect',
          saveAs: 'array',
          props: {
            id: 'additional_categories',
            name: 'additional_categories',
            label: 'Additional Categories',
            items: [
              { id: '', label: 'None' },
              { id: 'stress-analysis-gages', label: 'Stress Analysis Gages' },
              { id: 'transducer-class-gages', label: 'Transducer Class Gages' },
              { id: 'accessories', label: 'Accessories' },
              { id: 'special-use-gages', label: 'Special Use Gages' },
            ],
            onChange: (formik) => handleCategoryChange(formik, 'instruments'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'additional_qualifiers',
            name: 'additional_qualifiers',
            label: 'Additional Qualifiers',
            multiple: true,
            items: [],
            onLoad: (formik) => handleLoadQualifiers(formik, 'instruments'),
            onChange: (formik) => handleMultiSelectChange(formik, 'additional_qualifiers'),
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'image',
            name: 'images[0]',
            label: 'Image',
            styles: {
              formControlLabelRoot: { marginRight: 0 },
            },
            value: (formik) => formik.values.images[0],
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'res_id',
            name: 'res_id',
            label: 'Datasheet',
            styles: {
              formControl: { marginLeft: '16px' },
              formControlLabelRoot: { marginRight: 0 },
            },
            createBtnText: 'Create',
            createBtnAction: 'createNewDatasheet',
            editBtnText: 'Edit',
            editBtnAction: 'editExistingDatasheet',
            previewDocText: 'Preview',
            viewBtnAction: 'getDocumentLink',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'doc_number',
            name: 'doc_number',
            label: 'Document Number',
          },
        },
      ],
      datasheetTemplates: [5, 6, 8],
    },
    documentsDomain: '//docs.micro-measurements.com/?id=',
  },
  blh: {
    products: {
      initialValues: {
        name: '',
        long_name: '',
        description: '',
        keywords: [],
        related_products: [],
        weight: '',
        images: {},
        res_id: '',
        specifications: {},
        features: {},
        doc_number: '',
      },
      validationSchema: Yup.object({
        name: Yup.string().required('Required'),
      }),
      formFields: [
        {
          component: 'TextField',
          props: {
            id: 'name',
            name: 'name',
            label: 'Short Product Name',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'sku',
            name: 'sku',
            label: 'Sku',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'long_name',
            name: 'long_name',
            label: 'Long Product Name',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'description',
            name: 'description',
            label: 'Description',
            multiline: true,
          },
        },
        {
          component: 'TextField',
          saveAs: 'array', // for spliting string into an array (values separated by commas)
          props: {
            id: 'keywords',
            name: 'keywords',
            label: 'Keywords',
            multiline: true,
            onChange: (formik) => (e) => {
              formik.setFieldValue('keywords', e.target.value.split(','));
            },
          },
        },
        {
          component: 'TextField',
          saveAs: 'array', // for spliting string into an array (values separated by commas)
          props: {
            id: 'related_products',
            name: 'related_products',
            label: 'related_products',
            multiline: true,
            onChange: (formik) => (e) => {
              formik.setFieldValue('related_products', e.target.value.split(','));
            },
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'weight',
            name: 'weight',
            label: 'Weight',
            type: 'number',
          },
        },
        {
          component: 'Select',
          props: {
            id: 'type',
            name: 'specifications.type',
            label: 'Type',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'type'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.type'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'industry',
            name: 'specifications.industry',
            label: 'Industry',
            multiple: true,
            //value: (formik) => formik?.values?.specifications?.industry || '',
            value: (formik) => extractSpecification(formik, 'industry'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.industry'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'application',
            name: 'specifications.application',
            label: 'Application',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'application'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.application'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'certificates',
            name: 'specifications.certificates',
            label: 'Certificates',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'certificates'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.certificates'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'environment_protection_class',
            name: 'specifications.environment_protection_class',
            label: 'Environment Protection Class',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'environment_protection_class'),

            onChange: (formik) =>
              handleSelectChange(formik, 'specifications.environment_protection_class'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'material',
            name: 'specifications.material',
            label: 'Material',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'material'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.material'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'combined_error',
            name: 'specifications.combined_error',
            label: 'Combined Error',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'combined_error'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.combined_error'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'max_capacity_kn',
            name: 'specifications.max_capacity_kn',
            label: 'Max Capacity kN',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'max_capacity_kn'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.max_capacity_kn'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'max_capacity_k_lb',
            name: 'specifications.max_capacity_k_lb',
            label: 'Max Capacity K-LB',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'max_capacity_k_lb'),

            onChange: (formik) => handleSelectChange(formik, 'specifications.max_capacity_k_lb'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'max_capacity_ton',
            name: 'specifications.max_capacity_ton',
            label: 'Max Capacity Ton',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'max_capacity_ton'),

            onChange: (formik) => handleSelectChange(formik, 'specifications.max_capacity_ton'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'mounting_type',
            name: 'specifications.mounting_type',
            label: 'Mounting Type',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'mounting_type'),

            onChange: (formik) => handleSelectChange(formik, 'specifications.mounting_type'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'weighing_channels_single_multiple',
            name: 'specifications.weighing_channels_single_multiple',
            label: 'Weighing Channels Single Multiple',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'weighing_channels_single_multiple'),

            onChange: (formik) =>
              handleSelectChange(formik, 'specifications.weighing_channels_single_multiple'),
          },
        },
        {
          component: 'TextField',
          // for spliting string into an array (values separated by commas)
          props: {
            id: 'features',
            name: 'features.features',
            label: 'Features',
            multiline: true,
            multiple: true,
            value: (formik) => formik.values.features.features,
            onChange: (formik) => (e) => {
              formik.setFieldValue('features', '');
              formik.setFieldValue('features.features', e.target.value.split(','));
            },
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'image',
            name: 'images[0]',
            label: 'Image',
            value: (formik) => formik.values.images[0],
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'res_id',
            name: 'res_id',
            label: 'Datasheet',
            styles: {
              formControl: { marginLeft: '16px' },
              formControlLabelRoot: { marginRight: 0 },
            },
            createBtnText: 'Create',
            createBtnAction: 'createNewDatasheet',
            editBtnText: 'Edit',
            editBtnAction: 'editExistingDatasheet',
            previewDocText: 'Preview',
            viewBtnAction: 'getDocumentLink',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'doc_number',
            name: 'doc_number',
            label: 'Document Number',
          },
        },
      ],
      datasheetTemplates: [1, 8],
    },
    documentsDomain: '//docs.blhnobel.com/?id=',
  },
  vpgt: {
    products: {
      initialValues: {
        name: '',
        long_name: '',
        description: '',
        keywords: [],
        related_products: [],
        weight: '',
        images: {},
        res_id: '',
        designations: {},
        specifications: {},
        features: {},
        doc_number: '',
        dimensions: { length: {}, width: {}, height: {} },
      },
      validationSchema: Yup.object({
        name: Yup.string().required('Required'),
      }),
      formFields: [
        {
          component: 'TextField',
          props: {
            id: 'name',
            name: 'name',
            label: 'Short Product Name',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'sku',
            name: 'sku',
            label: 'Sku',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'long_name',
            name: 'long_name',
            label: 'Long Product Name',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'description',
            name: 'description',
            label: 'Description',
            multiline: true,
          },
        },
        {
          component: 'TextField',
          saveAs: 'array', // for spliting string into an array (values separated by commas)
          props: {
            id: 'keywords',
            name: 'keywords',
            label: 'Keywords',
            multiline: true,
            onChange: (formik) => (e) => {
              formik.setFieldValue('keywords', e.target.value.split(','));
            },
          },
        },
        {
          component: 'TextField',
          saveAs: 'array', // for spliting string into an array (values separated by commas)
          props: {
            id: 'related_products',
            name: 'related_products',
            label: 'related_products',
            multiline: true,
            onChange: (formik) => (e) => {
              formik.setFieldValue('related_products', e.target.value.split(','));
            },
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'weight',
            name: 'weight',
            label: 'Weight',
            type: 'number',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'optional',
            name: 'optional',
            label: 'Optional',
            multiline: true,
          },
        },
        {
          component: 'Select',
          props: {
            id: 'maxiuntervals',
            name: 'specifications.maxiuntervals',
            label: 'Maximum no. of intervals',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'type'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.type'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'ratedoutput',
            name: 'specifications.ratedoutput',
            label: 'Rated output-R.O',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'type'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.type'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'powersupply',
            name: 'specifications.powersupply',
            label: 'Power Supply',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'type'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.type'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'display',
            name: 'specifications.display',
            label: 'Display',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'type'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.type'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'productnature',
            name: 'specifications.productnature',
            label: 'product nature (digital/ analog)',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'type'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.type'),
          },
        },
        // {
        //   component: 'Select',
        //   props: {
        //     id: 'emaxvmin',
        //     name: 'specifications.emaxvmin',
        //     label: 'Y=Emax/Vmin',
        //     multiple: true,
        //     value: (formik) => extractSpecification(formik, 'type'),
        //     onChange: (formik) => handleSelectChange(formik, 'specifications.type'),
        //   },
        // },
        {
          component: 'Select',
          props: {
            id: 'type',
            name: 'specifications.type',
            label: 'Type',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'type'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.type'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'industry',
            name: 'specifications.industry',
            label: 'Industry',
            multiple: true,
            //value: (formik) => formik?.values?.specifications?.industry || '',
            value: (formik) => extractSpecification(formik, 'industry'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.industry'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'application',
            name: 'specifications.application',
            label: 'Applications listing',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'application'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.application'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'brand',
            name: 'specifications.brand',
            label: 'Brands',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'brand'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.brand'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'communication_protocols',
            name: 'specifications.communication_protocols',
            label: 'Communication protocols',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'communication_protocols'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.communication_protocols'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'loadcell_type',
            name: 'specifications.loadcell_type',
            label: 'Type of load cells',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'loadcell_type'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.loadcell_type'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'market_applications',
            name: 'specifications.market_applications',
            label: 'Market Applications',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'market_applications'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.market_applications'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'accuracy_class',
            name: 'specifications.accuracy_class',
            label: 'Accuracy class',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'accuracy_class'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.accuracy_class'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'communications_output',
            name: 'specifications.communications_output',
            label: 'Communication Output',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'communications_output'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.communications_output'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'regions',
            name: 'specifications.regions',
            label: 'Regions',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'regions'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.regions'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'certificates',
            name: 'specifications.certificates',
            label: 'Certificates',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'certificates'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.certificates'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'environment_protection_class',
            name: 'specifications.environment_protection_class',
            label: 'Enclosure Rating',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'environment_protection_class'),

            onChange: (formik) =>
              handleSelectChange(formik, 'specifications.environment_protection_class'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'material',
            name: 'specifications.material',
            label: 'Material',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'material'),
            onChange: (formik) => handleSelectChange(formik, 'specifications.material'),
          },
        },
        // {
        //   component: 'Select',
        //   props: {
        //     id: 'combined_error',
        //     name: 'specifications.combined_error',
        //     label: 'Combined Error',
        //     multiple: true,
        //     value: (formik) => extractSpecification(formik, 'combined_error'),
        //     onChange: (formik) => handleSelectChange(formik, 'specifications.combined_error'),
        //   },
        // },
        // {
        //   component: 'Select',
        //   props: {
        //     id: 'max_capacity_kn',
        //     name: 'specifications.max_capacity_kn',
        //     label: 'Max Capacity kN',
        //     multiple: true,
        //     value: (formik) => extractSpecification(formik, 'max_capacity_kn'),
        //     onChange: (formik) => handleSelectChange(formik, 'specifications.max_capacity_kn'),
        //   },
        // },
        // {
        //   component: 'Select',
        //   props: {
        //     id: 'max_capacity_k_lb',
        //     name: 'specifications.max_capacity_k_lb',
        //     label: 'Max Capacity k lbs',
        //     multiple: true,
        //     value: (formik) => extractSpecification(formik, 'max_capacity_k_lb'),
        //
        //     onChange: (formik) => handleSelectChange(formik, 'specifications.max_capacity_k_lb'),
        //   },
        // },
        // {
        //   component: 'Select',
        //   props: {
        //     id: 'max_capacity_ton',
        //     name: 'specifications.max_capacity_ton',
        //     label: 'Max Capacity kg',
        //     multiple: true,
        //     value: (formik) => extractSpecification(formik, 'max_capacity_ton'),
        //
        //     onChange: (formik) => handleSelectChange(formik, 'specifications.max_capacity_ton'),
        //   },
        // },
        // {
        //   component: 'Select',
        //   props: {
        //     id: 'min_capacity_kn',
        //     name: 'specifications.min_capacity_kn',
        //     label: 'Min Capacity kN',
        //     multiple: true,
        //     value: (formik) => extractSpecification(formik, 'min_capacity_kn'),
        //     onChange: (formik) => handleSelectChange(formik, 'specifications.min_capacity_kn'),
        //   },
        // },
        // {
        //   component: 'Select',
        //   props: {
        //     id: 'min_capacity_k_lb',
        //     name: 'specifications.min_capacity_k_lb',
        //     label: 'Min Capacity k lbs',
        //     multiple: true,
        //     value: (formik) => extractSpecification(formik, 'min_capacity_k_lb'),
        //
        //     onChange: (formik) => handleSelectChange(formik, 'specifications.min_capacity_k_lb'),
        //   },
        // },
        // {
        //   component: 'Select',
        //   props: {
        //     id: 'min_capacity_ton',
        //     name: 'specifications.min_capacity_ton',
        //     label: 'Min Capacity kg',
        //     multiple: true,
        //     value: (formik) => extractSpecification(formik, 'min_capacity_ton'),
        //
        //     onChange: (formik) => handleSelectChange(formik, 'specifications.min_capacity_ton'),
        //   },
        // },
        {
          component: 'Select',
          props: {
            id: 'nominal_capacity_unit',
            name: 'specifications.nominal_capacity_unit',
            label: 'Nominal capacity unit',
            value: (formik) => extractSpecification(formik, 'nominal_capacity_unit'),
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'nominal_capacity_value',
            name: 'specifications.nominal_capacity_value',
            label: 'Nominal capacity value',
            value: (formik) => extractSpecification(formik, 'nominal_capacity_value'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'mounting_type',
            name: 'specifications.mounting_type',
            label: 'Mounting Type',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'mounting_type'),

            onChange: (formik) => handleSelectChange(formik, 'specifications.mounting_type'),
          },
        },
        {
          component: 'Select',
          props: {
            id: 'weighing_channels_single_multiple',
            name: 'specifications.weighing_channels_single_multiple',
            label: 'Weighing Channels',
            multiple: true,
            value: (formik) => extractSpecification(formik, 'weighing_channels_single_multiple'),

            onChange: (formik) =>
              handleSelectChange(formik, 'specifications.weighing_channels_single_multiple'),
          },
        },
        {
          component: 'TextField',
          // for spliting string into an array (values separated by commas)
          props: {
            id: 'features',
            name: 'features.features',
            label: 'Features',
            multiline: true,
            multiple: true,
            value: (formik) => formik.values.features.features,
            onChange: (formik) => (e) => {
              formik.setFieldValue('features', '');
              formik.setFieldValue('features.features', e.target.value.split(','));
            },
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'image',
            name: 'images[0]',
            label: 'Image',
            value: (formik) => formik.values.images[0],
          },
        },
        {
          component: 'ResourceSpace',
          props: {
            id: 'res_id',
            name: 'res_id',
            label: 'Datasheet',
            styles: {
              formControl: { marginLeft: '16px' },
              formControlLabelRoot: { marginRight: 0 },
            },
            createBtnText: 'Create',
            createBtnAction: 'createNewDatasheet',
            editBtnText: 'Edit',
            editBtnAction: 'editExistingDatasheet',
            previewDocText: 'Preview',
            viewBtnAction: 'getDocumentLink',
          },
        },
        {
          component: 'TextField',
          props: {
            id: 'doc_number',
            name: 'doc_number',
            label: 'Document Number',
          },
        },
      ],
      // dimensions: {
      //   component: 'Dimensionsnew',
      // },
      // designations: {
      //   component: 'Designations',
      //   props: {
      //     fields: [
      //       { name: 'series', label: 'Series' },
      //       { name: 'stc', label: 'Stc' },
      //       { name: 'resistance', label: 'Resistance' },
      //       { name: 'options', label: 'Options' },
      //       { name: 'item_code', label: 'Item Code' },
      //       { name: 'materials', label: 'Materials' },
      //       { name: 'packaging', label: 'Packaging' },
      //     ],
      //     columns: [
      //       { id: 'designation', label: 'Designation' },
      //       { id: 'item_code', label: 'Item Code' },
      //       { id: 'materials', label: 'Materials' },
      //       { id: 'packaging', label: 'Packaging' },
      //       { id: 'edit' },
      //       { id: 'delete' },
      //     ],
      //     getKey: ({ series, stc, name, resistance, options }) => {
      //       return `${series || 'xxx'}-${stc || 'xxx'}-${name || 'xxx'}-${resistance || 'xxx'}${
      //         options ? `/${options}` : ''
      //       }`;
      //     },
      //   },
      // },
    },
    onSubmit: (values) => {
      if (values.designations && Object.keys(values.designations).length) {
        const stcSet = new Set();
        const seriesSet = new Set();
        const resistanceSet = new Set();
        const optionsSet = new Set();
        Object.keys(values.designations).forEach((key) => {
          stcSet.add(values.designations[key].stc);
          seriesSet.add(values.designations[key].series);
          resistanceSet.add(values.designations[key].resistance);
          optionsSet.add(values.designations[key].options);
        });

        values.specifications['stress_analysis_stc'] = Array.from(stcSet);
        values.specifications['stress_analysis_series'] = Array.from(seriesSet);
        values.specifications['stress_analysis_resistance'] = Array.from(resistanceSet);
        values.specifications['stress_analysis_options'] = Array.from(optionsSet);
      }
    },
    datasheetTemplates: [1, 8],
    documentsDomain: '//docs.blhnobel.com/?id=',
  },
};

export default formsConfig;
